import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { ACCOUNT, RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransfer247AuthService,
  fetchTransfer247CheckInfoService,
  fetchTransfer247ConfirmService,
  fetchTransfer247CreateService,
} from "../services/transfer-247.service";
import {
  fetchTransfer247AccountDetailFailure,
  fetchTransfer247AccountDetailSuccess,
  fetchTransfer247AuthorizationFailure,
  fetchTransfer247AuthorizationSuccess,
  fetchTransfer247ConfirmFailure,
  fetchTransfer247ConfirmSuccess,
  fetchTransfer247CreateFailure,
  fetchTransfer247CreateSuccess,
  fetchTransfer247MakeFeeFailure,
  fetchTransfer247MakeFeeSuccess,
} from "./actions";
import {
  FETCH_TRANSFER_247_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_247_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_247_CONFIRM_REQUEST,
  FETCH_TRANSFER_247_CREATE_REQUEST,
  FETCH_TRANSFER_247_MAKE_FEE_REQUEST,
} from "./actions.type";
import {
  FetchTransfer247AccountDetailRequest,
  FetchTransfer247AuthorizationRequest,
  FetchTransfer247ConfirmRequest,
  FetchTransfer247CreateRequest,
  FetchTransfer247MakeFeeRequest,
} from "./types";

function* fetchTransfer247AccountDetailSaga(action: FetchTransfer247AccountDetailRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransfer247CheckInfoService(action.payload));
    console.log("fetchTransfer247AccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const resTransfer = response.data.RESPONSEDATA?.TRANSFER;
      const accountProfile: ACCOUNT = {
        ACCOUNTNO: resTransfer?.CREDIT_ACCOUNT_NUMBER,
        ACCOUNTNAME: resTransfer?.CREDIT_ACCOUNT_NAME,
        ACCOUNTTYPE: resTransfer?.CREDIT_ACCOUNT_TYPE,
      };
      yield put(fetchTransfer247AccountDetailSuccess(accountProfile));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransfer247AccountDetailFailure(msg));
  }
}

function* fetchTransfer247MakeFeeSaga(action: FetchTransfer247MakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransfer247CreateService(action.payload));
    console.log("fetchTransfer247MakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransfer247MakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransfer247MakeFeeFailure(msg));
  }
}

function* fetchTransfer247CreateSaga(action: FetchTransfer247CreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransfer247CreateService(action.payload));
    console.log("fetchTransfer247Create response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransfer247CreateSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransfer247CreateFailure(msg));
  }
}

function* fetchTransfer247ConfirmSaga(action: FetchTransfer247ConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransfer247ConfirmService(action));
    console.log("fetchTransfer247Confirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransfer247ConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransfer247ConfirmFailure(msg));
  }
}

function* fetchTransfer247AuthSaga(action: FetchTransfer247AuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransfer247AuthService(action));
    console.log("fetchTransfer247Auth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransfer247AuthorizationSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransfer247AuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* transfer247Saga() {
  yield all([
    takeLatest(FETCH_TRANSFER_247_ACCOUNT_DETAIL_REQUEST, fetchTransfer247AccountDetailSaga),
    takeLatest(FETCH_TRANSFER_247_MAKE_FEE_REQUEST, fetchTransfer247MakeFeeSaga),
    takeLatest(FETCH_TRANSFER_247_CREATE_REQUEST, fetchTransfer247CreateSaga),
    takeLatest(FETCH_TRANSFER_247_CONFIRM_REQUEST, fetchTransfer247ConfirmSaga),
    takeLatest(FETCH_TRANSFER_247_AUTHORIZATION_KEY_REQUEST, fetchTransfer247AuthSaga),
  ]);
}

export default transfer247Saga;
